import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { GroupStoreActions, GroupStoreSelectors } from '@era/stores';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { CreateGroupCommand, Group } from '@rocksoft/security-sdk';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AddGroupModalComponent } from '../add-group-modal/add-group-modal.component';
import { GroupListViewComponent } from './group-list-view.component';

@Component({
  selector: 'era-group-list-view',
  templateUrl: './group-list-view.container.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [GroupListViewComponent],
})
export class GroupListViewContainerComponent {
  private readonly store = inject(Store);
  private readonly actions$ = inject(Actions);
  private readonly modalService = inject(NgbModal);

  public readonly groups = this.store.selectSignal(GroupStoreSelectors.selectAllGroups);
  public readonly error$: Observable<string>;
  public editEnabled = false;

  constructor() {
    this.error$ = this.actions$.pipe(
      ofType(GroupStoreActions.GroupApiActions.groupsLoadedError),
      map(() => 'An unknown error has occurred.')
    );
  }

  toggleEditEvent(): void {
    this.editEnabled = !this.editEnabled;
  }

  addGroupEvent(): void {
    const modelRef = this.modalService.open(AddGroupModalComponent);

    modelRef.result.then(
      (result: CreateGroupCommand) => {
        this.store.dispatch(GroupStoreActions.GroupListUIActions.groupAddRequested({ group: result }));
      },
      () => {
        return;
      }
    );
  }

  onDeleteRequested(group: Group): void {
    this.store.dispatch(GroupStoreActions.GroupListItemUIActions.groupDeleteRequested({ group }));
  }
}
